<script>
import { useOperationStore } from "@/stores/operation";

export default {
  name: "StoreMapperView",

  data() {
    return {
      id: "cm9b2r86y00012ygfxykhgd4p",
      checkedShop: "",
      prevCheckedShop: "",
      visibleShops: [],
      allShops: [],
      mapInstance: null,
      showMapMobile: true,
    };
  },

  computed: {
    custom() {
      return useOperationStore().customData;
    },

    customStyle() {
      return JSON.stringify({
        ".filter-select": {
          display: "none!important",
        },
        ".search-input": {
          "background-color": `${this.custom?.primary_color_bg}!important`,
          color: `${this.custom?.primary_color_txt}!important`,
          flex: "1!important",
          "max-width": "none!important",
          "font-size": "16px!important",
          padding: "12px 0px !important",
          margin: "0px 0px !important",
          height: "auto !important",
        },
        ".search-btn": {
          margin: "0px !important",
          "border-radius": "4px !important",
        },
        ".search-btn button": {
          "font-size": "14px !important",
          padding: "14px 25px !important",
          margin: "0px 15px !important",
          height: "auto !important",
        },
        ".search-container": {
          width: "100%!important",
          display: "flex!important",
          "justify-content": "space-between!important",
          "font-family": "Arial, sans-serif!important",
          margin: "0px!important",
          padding: "5px!important",
        },
        ".search-button": {
          "font-family": "Arial, sans-serif!important",
        },
        "#map": {
          "min-height": "500px!important",
        },
      });
    },
  },

  methods: {
    setupEventListeners() {
      document.addEventListener(
        "storesPointsInMap",
        this.handleStoresPointsInMap
      );
      document.addEventListener(
        "storePointSelected",
        this.handleStorePointSelected
      );
    },

    removeEventListeners() {
      document.removeEventListener(
        "storesPointsInMap",
        this.handleStoresPointsInMap
      );
      document.removeEventListener(
        "storePointSelected",
        this.handleStorePointSelected
      );
    },

    handleStorePointSelected(event) {
      this.checkedShop = event.detail.id;
    },

    handleStoresPointsInMap(event) {
      this.visibleShops = event.detail.storesPoints;
      if (this.allShops.length === 0) {
        this.allShops = this.visibleShops;
      }
    },

    openPoint(id, isMobile = false) {
      if (isMobile) {
        this.showMapMobile = !this.showMapMobile;
      }

      const merchantId = id;

      if (this.prevCheckedShop) {
        const prevShopElement = document.getElementById(
          `shop-${this.prevCheckedShop}`
        );
        if (prevShopElement) {
          prevShopElement.classList.remove("shop-highlight");
        }
      }

      const checkedShopElement = document.getElementById(`shop-${merchantId}`);
      checkedShopElement.classList.add("shop-highlight");

      this.prevCheckedShop = merchantId;

      this.mapInstance?.dispatchEvent(
        new CustomEvent("selectStorePoint", {
          detail: {
            storePointId: merchantId,
          },
        })
      );
    },

    async loadStoreLocatorScript() {
      return new Promise((resolve) => {
        if (!document.getElementById("store-locator-script")) {
          const script = document.createElement("script");
          script.id = "store-locator-script";
          script.src =
            "https://store-locator-promodev.netlify.app/widget/store-locator-widget.es.js";
          script.onload = () => resolve(true);
          document.body.appendChild(script);
        } else {
          resolve(true);
        }
      });
    },

    createMapInstance() {
      const element = document.createElement("map-store-locator");

      element.setAttribute("id", "map-store-locator");
      element.setAttribute("search", "top");
      element.setAttribute(
        "color-txt-btn",
        this.custom?.secondary_color_txt || ""
      );
      element.setAttribute("color-btn", this.custom?.secondary_color_bg || "");
      element.setAttribute("custom-style", this.customStyle);
      element.setAttribute("data-token", this.id);
      element.setAttribute("locale", "FR");
      element.setAttribute("country-search", "FR");

      return element;
    },
  },

  async mounted() {
    await this.loadStoreLocatorScript();
    this.setupEventListeners();

    const container = document.querySelector(".map-container");
    if (container) {
      this.mapInstance = this.createMapInstance();
      container.appendChild(this.mapInstance);
    }
  },

  beforeDestroy() {
    this.removeEventListeners();
    if (this.mapInstance) {
      this.mapInstance.remove();
      this.mapInstance = null;
    }
  },

  watch: {
    checkedShop(newVal) {
      this.$nextTick(() => {
        const shopElement = document.getElementById(`shop-${newVal}`);
        if (shopElement) {
          if (this.prevCheckedShop && this.prevCheckedShop !== newVal) {
            const prevShopElement = document.getElementById(
              `shop-${this.prevCheckedShop}`
            );
            if (prevShopElement) {
              prevShopElement.classList.remove("shop-highlight");
            }
          }
          shopElement.classList.add("shop-highlight");
          this.prevCheckedShop = newVal;

          shopElement.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "center",
          });

          setTimeout(() => {
            shopElement.classList.add("highlight");
            setTimeout(() => shopElement.classList.remove("highlight"), 500);
          }, 300);
        }
      });
    },
  },
};
</script>

<template>
  <div
    class="h-full min-h-[90vh] desktop:max-h-none w-full overflow-hidden flex flex-wrap items-start desktop:items-stretch desktop:pt-0 pt-20 relative"
  >
    <!-- Toggle switch (mobile uniquement) -->
    <div
      class="w-full p-4 flex justify-center h-20 desktop:hidden absolute top-0"
    >
      <div class="toggle-container">
        <button
          @click="showMapMobile = true"
          :class="['toggle-btn', showMapMobile ? 'active' : '']"
        >
          <i class="fas fa-map-marker-alt"></i>
        </button>
        <button
          @click="showMapMobile = false"
          :class="['toggle-btn', !showMapMobile ? 'active' : '']"
        >
          <i class="fas fa-list"></i>
        </button>
        <div
          class="toggle-slider"
          :class="{ 'slide-right': !showMapMobile }"
        ></div>
      </div>
    </div>

    <!-- Liste des revendeurs (desktop) -->
    <div
      id="storelist"
      class="w-full desktop:block hidden desktop:w-2/6 desktop:h-full overflow-y-auto"
    >
      <ul class="text-sm p-4">
        <li
          :id="`shop-${shop.id}`"
          class="mb-4 border-b pb-2 cursor-pointer"
          @click="openPoint(shop.id, false)"
          v-for="(shop, i) in allShops"
          :key="i"
        >
          <h3 class="font-bold text-secondary-bg">{{ shop.name }}</h3>
          <p>
            <span>{{ shop.address.line1 }}</span>
            <span v-if="shop.address.postalCode"
              >, {{ shop.address.postalCode }}</span
            >
            <br />
            <span v-if="shop.address.city">{{ shop.address.city }}</span>
          </p>
          <p></p>
        </li>
      </ul>
    </div>

    <!-- Map (desktop & mobile) -->
    <div
      class="w-full desktop:w-4/6 map-container"
      :class="{ hidden: !showMapMobile }"
    >
      <!-- Le map-store-locator sera injecté ici dynamiquement -->
    </div>
    <div
      class="w-full desktop:w-4/6 map-container"
      :class="{ hidden: !showMapMobile }"
    >
      <!-- Le map-store-locator sera injecté ici dynamiquement -->
    </div>

    <!-- Liste des revendeurs (mobile) -->
    <div
      id="storelist"
      class="w-full block desktop:hidden h-full desktop:w-2/6 desktop:h-full overflow-y-auto"
      :class="{ hidden: showMapMobile }"
    >
      <ul class="text-sm p-4">
        <li
          :id="`shop-${shop.id}`"
          class="mb-4 border-b pb-2 cursor-pointer"
          @click="openPoint(shop.id, true)"
          v-for="(shop, i) in allShops"
          :key="i"
        >
          <h3 class="font-bold text-secondary-bg">{{ shop.name }}</h3>
          <p>
            <span>{{ shop.address.line1 }}</span>
            <span v-if="shop.address.postalCode"
              >, {{ shop.address.postalCode }}</span
            >
            <br />
            <span v-if="shop.address.city">{{ shop.address.city }}</span>
          </p>
          <p></p>
        </li>
      </ul>
    </div>
  </div>
</template>

<style scoped>
.shop-highlight {
  box-shadow: 0 0 10px rgba(255, 0, 0, 0.5) !important;
  transition: all 0.3s ease !important;
  background-color: #fff8f8 !important;
  border-radius: 12px !important;
  padding: 16px !important;
  margin: 8px 0 !important;
  transform: scale(1.02) !important;
}

.highlight {
  box-shadow: 0 0 10px rgba(255, 0, 0, 0.8) !important;
  transition: all 0.5s ease !important;
  background-color: #ffe0e0 !important;
  transform: scale(1.05) !important;
  font-weight: bold !important;
  padding: 20px !important;
  margin: 8px 0 !important;
  border-radius: 12px !important;
}

.toggle-container {
  position: relative;
  background: linear-gradient(
    25deg,
    #08a7cc,
    #398cab 43%,
    #d93241 58%,
    #e72a38
  ) !important;
  border-radius: 25px;
  padding: 3px;
  display: flex;
  width: 120px;
  height: 40px;
}

.toggle-btn {
  position: relative;
  z-index: 1;
  width: 50%;
  border: none;
  background: none;
  color: white;
  cursor: pointer;
  transition: color 0.3s;
}

.toggle-btn.active {
  color: black;
}

.toggle-slider {
  position: absolute;
  top: 3px;
  left: 3px;
  width: calc(50% - 3px);
  height: calc(100% - 6px);
  background-color: white;
  border-radius: 20px;
  transition: transform 0.3s ease;
}

.toggle-slider.slide-right {
  transform: translateX(100%);
}
</style>
